module.exports = __webpack_public_path__ + "img/Hexagon-header-4.0bcf655c.svg";